export default __webpack_public_path__ + "static/media/GridOff.f1073a59.webp";